const storage = new Proxy({}, {
    get(target, prop) {
        const value = localStorage.getItem(prop);
        if (value !== null) {
            try {
                return JSON.parse(value);
            } catch (error) {
                return value;
            }
        } else {
            return null;
        }
    },

    set(target, prop, value) {
        const serializedValue = typeof value === 'string' ? value : JSON.stringify(value);
        localStorage.setItem(prop, serializedValue);
        return true;
    },

    deleteProperty(target, prop) {
        localStorage.removeItem(prop);
        return true;
    }
});

// eslint-disable-next-line no-unused-vars
const FILTER_PRODUCTS_BY_STORE = (storage.sellerId && storage.filterProductsOnBranch) || false;
